import { Button, buttonStyle } from 'components/button/Button';
import { defaultButtonStyle } from 'components/button/DefaultButton';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { link, navBorderColor, primaryText } from 'styles/theme';

export const LinkButton = styled.a`
    ${buttonStyle}
    ${defaultButtonStyle}

    display: inline-block;
    text-decoration: none;
`;

export const MenuLink = styled(NavLink)<{ $active?: boolean; $padding?: string }>`
    padding-left: ${({ $padding }) => $padding || '1.5rem'};
    padding-right: ${({ $padding }) => $padding || '1.5rem'};
    display: flex;
    align-items: center;
    height: 100%;

    border-bottom-width: 2px;
    border-bottom-style: solid;
    border-bottom-color: ${(props) => (props.$active ? link : 'transparent')};

    color: ${primaryText};

    &:hover {
        border-bottom-color: ${(props) => (props.$active ? link : navBorderColor)};
    }
`;

export const MenuButton = styled(Button)<{ $active?: boolean }>`
    width: 4.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;

    color: var(--icon-action-active);

    &:hover {
        color: ${(props) =>
            props.$active ? 'var(--icon-action-selected)' : 'var(--icon-action-hover)'};
    }

    &:active {
        color: var(--icon-action-selected);
    }
`;
